import { ErrorMessage } from '../../helpers/forms';
import { IEditableUserAttributes } from '../../interfaces/rutilus/user';
import { IOptionType } from '../Select/Select';

interface IState {
  attributes: IEditableUserAttributes;
  errorMessages: ErrorMessage[];
  isSaving: boolean;
  didChange: boolean;
}

type TAction =
  | { type: 'updateField'; field: string; value: string }
  | { type: 'updateCountry'; value: IOptionType }
  | { type: 'submit' }
  | { type: 'submitSuccess' }
  | { type: 'submitError'; errorMessages: ErrorMessage[] };

export const userProfileReducer = (state: IState, action: TAction): IState => {
  switch (action.type) {
    case 'updateField':
      return {
        ...state,
        attributes: { ...state.attributes, [action.field]: action.value },
        didChange: true,
      };
    case 'updateCountry':
      return {
        ...state,
        attributes: { ...state.attributes, country_code: action.value.value },
        didChange: true,
      };
    case 'submit':
      return {
        ...state,
        isSaving: true,
      };
    case 'submitSuccess':
      return {
        ...state,
        isSaving: false,
        didChange: false,
        errorMessages: [],
      };
    case 'submitError':
      return {
        ...state,
        isSaving: false,
        errorMessages: action.errorMessages,
      };
    default:
      return state;
  }
};
